import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import {
  getIsVenue,
  getSupplier,
  getSupplierPackages,
  getVenuePackages,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import PricingComponent, {
  IProps as PricingProps,
} from '@bridebook/web/app-basic/components/supplier/sections/pricing/pricing';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { useSupplierAccordion } from '../hooks/use-supplier-accordion';
import ToggleEnquiryFormButton from '../toggle-enquiry-form-button';

const Pricing = () => {
  const supplier = useSelector(getSupplier);
  const isVenue = useSelector(getIsVenue);
  const packages = useSelector(getVenuePackages);
  const supplierCountryCode = useSelector((state) => state.supplier?.supplier?.l10n?.country);
  const info = useSelector((state) => state.supplier.supplier?.pricing?.description);
  const basePrice = useSelector((state) => state.supplier.supplier?.pricing?.base);
  const maxPrice = useSelector((state) => state.supplier.supplier?.pricing?.maximum);
  const accordionProps = useSupplierAccordion();
  const market = useMarket();
  const supplierPackages = useSelector(getSupplierPackages);
  const isMobile = useSelector(getIsMobile);

  if (!supplier) return null;

  const toggleEnquiryFormButton = (
    <ToggleEnquiryFormButton contactMethod="supplierProfile_pricingSection" />
  );

  const props: PricingProps = {
    accordionProps,
    basePrice,
    currency: market.currency,
    info,
    isMobile,
    isVenue,
    market,
    maxPrice,
    openStatic: true,
    packages,
    showAllInfoText: false,
    supplier,
    supplierCountryCode,
    supplierPackages,
    toggleEnquiryFormButton,
  };

  return <PricingComponent {...props} />;
};

export default Pricing;
